import { TreeDataValue } from "@/core/libs/tree-select-dropdown/TreeSelectDropdown";
import { BusinessUnit, BusinessUnitRegion } from "@/modules/User/types/types";

/**
 * Converte uma árvore de BusinessUnit em nós para um componente de seleção em árvore.
 */
const formatBUChildren = (businessUnits: BusinessUnit[]): TreeDataValue[] => {
  if (!businessUnits || businessUnits.length === 0) return [];

  return businessUnits.map(bu => ({
    label: bu.name,
    value: bu.id,
    children: bu.children ? formatBUChildren(bu.children) : [],
    checked: false
  }));
};

/**
 * Converte unidades de negócio em nós para um componente de seleção em árvore.
 * Lida com estruturas tanto planas (BusinessUnit[]) quanto classificadas (BusinessUnitRegion[]).
 */
export const formatBUList = (
  businessUnits?: BusinessUnit[],
  businessUnitClassification?: BusinessUnitRegion[]
): TreeDataValue[] => {
  if (businessUnitClassification?.length > 0) {
    return businessUnitClassification.map(classification => ({
      label: classification.region,
      value: `region-${classification.region}`,
      checked: false,
      children: classification.segments.map(segment => ({
        label: segment.segment,
        value: `segment-${segment.segment}`,
        checked: false,
        children: formatBUChildren(segment.businessUnits)
      }))
    }));
  }

  if (businessUnits?.length > 0) {
    return formatBUChildren(businessUnits);
  }

  return [];
};
